import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DominioService } from '../_services/dominio.service';

@Injectable({ providedIn: 'root'})
export class CompaniesResolver implements Resolve<Observable<any[]>>{

    constructor(private service: DominioService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> {
        return this.service.getCompanys();
    }
}